import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { faqs } from '../data/content';
export function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section id="faq" className="bg-pearl-50 py-14 dark:bg-slate-950 sm:py-20" aria-labelledby="faq-heading" data-id="element-62" data-mp="1lc1yr8r0kvp2">
      <div className="mx-auto grid max-w-6xl gap-8 px-5 sm:gap-10 sm:px-8 lg:grid-cols-[0.8fr_1.2fr] lg:gap-16" data-id="element-63" data-mp="1gal2xrndzzfc">
        <div data-id="element-64" data-mp="291d473jb7e9j">
          <p className="text-xs font-semibold uppercase tracking-[0.16em] text-plum-500 dark:text-plum-300" data-id="element-65" data-mp="291mme4y44h4o">
            FAQ
          </p>
          <h2 id="faq-heading" className="mt-3 font-display text-3xl font-semibold tracking-tight text-slate-900 dark:text-pearl-50 sm:text-4xl" data-id="element-66" data-mp="240yy3r19qee5">
            Frequent questions
          </h2>
        </div>

        <ul className="divide-y divide-slate-200 border-y border-slate-200 dark:divide-slate-800 dark:border-slate-800" data-id="element-67" data-mp="soo9zxxgz6g1">
          {faqs.map((faq, i) => {
          const isOpen = openIndex === i;
          return <li key={faq.question} data-id="element-68" data-mp="pipllyotkd4v" data-mpi={i}>
                <h3 data-id="element-69" data-mp="ugr5glu2kghe">
                  <button type="button" onClick={() => setOpenIndex(isOpen ? null : i)} aria-expanded={isOpen} aria-controls={`faq-panel-${i}`} className="flex w-full items-start justify-between gap-4 py-5 text-left transition-colors hover:text-plum-500 dark:hover:text-plum-300 sm:gap-6" data-id="element-70" data-mp="uhapq976zgyl">
                    <span className="font-display text-base font-semibold text-slate-900 dark:text-pearl-50 sm:text-lg" data-id="element-71" data-mp="6qwsm49r2rx5">
                      {faq.question}
                    </span>
                    <PlusIcon className={`mt-1 h-5 w-5 flex-none text-slate-500 transition-transform duration-300 dark:text-slate-400 ${isOpen ? 'rotate-45' : ''}`} aria-hidden="true" data-id="element-72" data-mp="3sywow43bo8d4" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-73" data-mp="3jz1a7pak5v8c">
                  {isOpen && <motion.div id={`faq-panel-${i}`} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.28,
                ease: [0.22, 1, 0.36, 1]
              }} className="overflow-hidden" data-id="element-74" data-mp="3nzk0vg0psv8y">
                      <p className="pb-5 pr-2 leading-relaxed text-slate-600 dark:text-slate-300 sm:pr-10" data-id="element-75" data-mp="1fszs0aevxxau">
                        {faq.answer}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}